import { computed, ref } from "vue"
import { useStore } from "vuex"
import { mapBasketItemToGa4, trackAddShippingInfo } from 'foundation/js/ecommerceTracking'
import GetLabel from "foundation/js/getLabel"
import { addNDaysToDate } from "foundation/js/utils/dateUtils"
import CheckoutStepTwo from "../CheckoutStepTwo/CheckoutStepTwo.vue"
import FormInputTextarea from "../FormInputTextarea/FormInputTextarea.vue"
import FormInputTextField from "../FormInputTextField/FormInputTextField.vue"
import FormInputDateField from "../FormInputDateField/FormInputDateField.vue"

export default {
    name: "FrivilligeCheckoutStepTwo",
    components: {
        CheckoutStepTwo,
        FormInputTextarea,
        FormInputTextField,
        FormInputDateField,
    },
    setup() {
        const store = useStore()

        const udlaanStartDate = ref(store.state.checkout.purchaseData?.udlaansData?.startDate ?? null)
        const udlaanEndDate = ref(store.state.checkout.purchaseData?.udlaansData?.endDate ?? null)
        const udlaanComment = ref(store.state.checkout.purchaseData?.udlaansData?.comment ?? null)

        const udlaanMinStartDate = addNDaysToDate(new Date(), 3)        
        const udlaanMinEndDate = computed(() => {
            return udlaanStartDate.value
                ? addNDaysToDate(new Date(udlaanStartDate.value), 1)
                : udlaanMinStartDate
        })

        const displayError = ref(false)

        const containsUdlaansvare = computed(() => store.state.basket.basketState.containsUdlaansvare)

        const onSubmit = (deliveryPayload) => {
            displayError.value = true
            if (deliveryPayload && (!containsUdlaansvare.value || validateUdlaanPeriode())) {
                store.commit('checkout/set_purchase_data_delivery', deliveryPayload)

                // update the active delivery address (initially is set to invoice address)
                store.commit('checkout/set_active_delivery_address', deliveryPayload)
                // set udlaan period
                store.commit('checkout/set_udlaans_data', {
                    startDate: udlaanStartDate.value,
                    endDate: udlaanEndDate.value,
                    comment: udlaanComment.value
                })

                const shippingTier = store.state.checkout.stepTwo.showPickUpAddresses ? 'Afhentningssted' : 'Hjemmelevering'
                const items = store.state.basket.basket
                trackAddShippingInfo(items.map((item, index) => mapBasketItemToGa4(item, index)), shippingTier)

                // if succes set step to next stepNumber
                store.commit('checkout/update_checkout_step',{nextStepNumber: 3})

                displayError.value = false
            }
        }

        const validateUdlaanPeriode = () => udlaanStartDateValidator(udlaanStartDate.value) && udlaanEndDateValidator(udlaanStartDate.value, udlaanEndDate.value)
        const udlaanStartDateValidator = (startDate) => getDate(new Date()) <= getDate(new Date(startDate))
        const udlaanEndDateValidator = (startDate, endDate) => 
            getDate(new Date()) < getDate(new Date(endDate)) && getDate(new Date(startDate)) < getDate(new Date(endDate))

        const isUdlaanStartDateValid = computed(() => displayError.value && !udlaanStartDateValidator(udlaanStartDate.value))
        const isUdlaanEndDateValid = computed(() => displayError.value && !udlaanEndDateValidator(udlaanStartDate.value, udlaanEndDate.value))

        const getDate = (date) => {
            return date 
                ? parseInt(
                    new Date(date).toISOString()
                        .split('T')[0]
                        .replaceAll('-', '')
                ) 
                : null
        }

        return {
            containsUdlaansvare,
            udlaanStartDate,
            udlaanEndDate,
            udlaanComment,
            udlaanMinStartDate,
            udlaanMinEndDate,
            isUdlaanStartDateValid,
            isUdlaanEndDateValid,
            onSubmit,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: "checkout", allowEmpty: true })
        }
    }
}